import Colors from "./Colors";
import Images from "./Images";

export { Colors, Images };



// WEBPACK FOOTER //
// ./src/Themes/index.ts